module.exports = __webpack_public_path__ + "img/1e4a24d.png";